<div class="ficha-bloqueada">
  <div class="fb-mock" aria-hidden="true">
    <div class="fb-bloco fb-topo">
      <div class="fb-barra fb-titulo"></div>
      <div class="fb-barra fb-linha"></div>
    </div>

    <div class="fb-resumo">
      <div class="fb-bloco" *ngFor="let item of resumo">
        <div class="fb-barra fb-curta"></div>
        <div class="fb-barra fb-media"></div>
      </div>
    </div>

    <div class="fb-bloco">
      <div class="fb-barra fb-subtitulo"></div>
      <div class="fb-numeros">
        <div class="fb-celula" *ngFor="let item of numeros">
          <div class="fb-barra fb-curta"></div>
          <div class="fb-barra fb-media"></div>
        </div>
      </div>
    </div>

    <div class="fb-bloco" *ngFor="let empresa of empresas">
      <div class="fb-barra fb-subtitulo"></div>
      <div class="fb-barra fb-linha"></div>
      <div class="fb-barra fb-linha"></div>
    </div>
  </div>

  <div class="fb-sobreposicao">
    <div class="fb-cartao" role="alert">
      <mat-icon fontSet="material-symbols-outlined" class="fb-icone">lock</mat-icon>
      <h2 class="fb-titulo-cartao">
        Destrave as obras do módulo<span *ngIf="nomeModulo">
          de <strong>{{ nomeModulo }}</strong></span
        ><span *ngIf="!nomeModulo"> deste módulo</span>
      </h2>
      <p class="fb-texto">
        Entre em contato com o nosso time para contratar e ter acesso às fichas
        completas, contatos e documentos de obras do segmento! 
      </p>
      <a
        class="fb-botao"
        [href]="getUpgradeLink()"
        target="_blank"
        rel="noopener noreferrer"
      >
        Quero acessar o módulo
      </a>
    </div>
  </div>
</div>